import { render, staticRenderFns } from "./PeopleComissions.vue?vue&type=template&id=67216b94&"
import script from "./PeopleComissions.vue?vue&type=script&lang=ts&"
export * from "./PeopleComissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports